module.exports = __webpack_public_path__ + "img/img-1-md-2x.3d8bab5.png";